<template>
  <div>
    <el-table :data="receiveDetailList" style="width: 100%" :header-cell-style="{
        background: '#E8E8E8'
      }" border>
      <el-table-column prop="rowNumber" label="行项目号" align="center" />
      <el-table-column prop="itemCode" label="物料编码" align="center" />
      <el-table-column prop="itemName" label="物料名称" align="center" />
      <el-table-column label="明细项状态" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.detailStatus === 1">有效</span>
          <span v-if="scope.row.detailStatus === 0">关闭</span>
        </template>
      </el-table-column>
      <el-table-column prop="itemAmount" label="总金额(元)" align="center">
        <template slot-scope="scope">
          {{ formatPrice(scope.row.itemAmount) }}
        </template>
      </el-table-column>
      <el-table-column  label="收货金额(元)" align="center">
        <template slot-scope="scope">
          {{ formatPrice(scope.row.receiveAmount) }}
        </template>
      </el-table-column>
      <el-table-column  label="冲销金额(元)" align="center">
        <template slot-scope="scope">
          {{ formatPrice(scope.row.reverseAmount) }}
        </template>
      </el-table-column>
      <el-table-column label="实际收货金额(元)" align="center" width="200px">
        <template slot-scope="scope">
          {{ formatPrice(scope.row.actualReceiveAmount) }}
        </template>
      </el-table-column>
      <el-table-column label="最后一次收货" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.isLast === 1">是</span>
          <span v-if="scope.row.isLast === 0">否</span>
        </template>
      </el-table-column>
    </el-table>
    <!-- 审批按钮 -->
    <div class="urgent-footer">
      <DialogPop @confirm="urgentAgree" isType="0" btnText="确认收货凭证" centerText="是否确认收货凭证？">
      </DialogPop>
    </div>
  </div>
</template>

<script>
import DialogPop from "./dialog-pop.vue"
import gameplanApi from "@/api/gameplan"
import { create, all } from 'mathjs'
const math = create(all, {})
export default {
  name: 'ApprovalDetailUrgent',
  components: {
    DialogPop
  },
  props: {
    receiveDetailList: {
      type: Array,
      default: () => {
        return []
      }
    },
    detailList: {
      type: Object,
      default: () => {
        return {}
      }
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {},
  methods: {
    // 紧急通过
    async urgentAgree() {
      if(this.loading) return
      this.$emit('update:loading',true)
      const params = {
        receiveId:this.detailList.receiveId,
      }
      const { data } = await gameplanApi.addAttachCheck(params)
      if (data.resultCode === "0") {
        this.$message.success('紧急审批已通过');
        this.$router.go(-1)
      } else {
        this.$message.error(data.resultMsg);
      }
      this.$emit('update:loading',false)
    },
    // 金额千分
    formatPrice(price) {
      return String(price).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
}
</script>
<style lang='scss' scoped>
.urgent-footer {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 100px;
  line-height: 30px;
  font-size: 14px;
  text-align: center;
}
</style>
